import { Box, Stack, Typography, useTheme } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useGetChangeTypeAudits } from "../my-schedules/my-custom-schedules/lib/use-get-changeType-audits"
import Iconify from "minimals-template/components/Iconify"
import { TruncatedTypography } from "lib/@components/truncated-typography"

export function ReasonComponentComparison({ item, changeType }) {
    const theme = useTheme()
    const { referenceId, draftId } = useBoundContext()
    const { loading, latestReason, createdBy, createdDate } = useGetChangeTypeAudits(
        referenceId,
        changeType,
        draftId,
        item?.taskId
    )

    if (loading || !latestReason) return null

    return (
        <Stack
            backgroundColor={theme.palette.grey[200]}
            spacing={1}
            sx={{ borderRadius: 1, width: "100%" }}
            p={1}
            mt={3}
            data-cy="reason-for-change-comparison"
        >
            <Stack
                direction="row"
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        alignItems: "center",
                    }}
                >
                    <Iconify icon="basil:comment-solid" sx={{ color: "primary.main", width: "20px", height: "20px" }} />
                    <Typography variant="subtitle2">Justification</Typography>
                </Stack>
            </Stack>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{latestReason}</Typography>

            <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                <Box sx={{ flex: 1, maxWidth: "fit-content" }}>
                    <TruncatedTypography variant={"caption"} sx={{ color: "text.secondary", maxWidth: "fit-content" }}>
                        {createdBy}
                    </TruncatedTypography>
                </Box>
                <TruncatedTypography variant={"caption"} sx={{ color: "text.secondary" }}>
                    , {createdDate}
                </TruncatedTypography>
            </Box>
        </Stack>
    )
}
